<div class="content">
  <div class="info-message">{{ 'AUTOMATIONS.EDITOR.TASKS.START_CAMPAIGN_FOR_COMPANY.LABEL' | translate }}</div>
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.COMMON.CAMPAIGN"
    hint="AUTOMATIONS.EDITOR.TASKS.START_CAMPAIGN_FOR_COMPANY.HINT"
    [dataService]="campaignSelectorService"
    [formControl]="campaignIdControl"
    [supportDataPassing]="false"
    [multiple]="false"
    [isRequired]="true"
    [disableIfTemplate]="true"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
</div>
